"use strict";
/**
 * @file Created on 03.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Tomas Leity
 */

var ConverterUtils =
/*#__PURE__*/
function () {
  function ConverterUtils() {
    _classCallCheck(this, ConverterUtils);
  }

  _createClass(ConverterUtils, null, [{
    key: "toBigNumberOrNull",

    /**
     * Checks value and converts the value into BigDecimal.
     * @param conversions
     * @param value
     */
    value: function toBigNumberOrNull(conversions, value) {
      return value ? conversions.toBigNumber(value) : null;
    }
    /**
     * Checks value and converts the value from BigDecimal.
     * @param conversions
     * @param value
     */

  }, {
    key: "fromBigNumberOrNull",
    value: function fromBigNumberOrNull(conversions, value) {
      return value ? conversions.fromBigNumber(value) : null;
    }
  }]);

  return ConverterUtils;
}();

exports.ConverterUtils = ConverterUtils;